import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { environment } from '../../environments/environment';
import { NecDataLayerService } from './nec-datalayer.service';

@Injectable({ providedIn: 'root' })
export class NecPageTrackingService {
    private previousUrl = '';
    private lastUrl = '';

    constructor(
        router: Router,
        private readonly dataLayer: NecDataLayerService,
        @Inject(PLATFORM_ID) platformId: object,
        @Inject(DOCUMENT) private readonly document: Document,
    ) {
        if (!isPlatformBrowser(platformId)) return;
        router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => this.schedule());
    }

    private schedule(): void {
        queueMicrotask(() => requestAnimationFrame(() => this.track()));
    }

    private track(): void {
        const win = this.document.defaultView!;
        const url = win.location.href;
        if (url === this.lastUrl) return;
        this.dataLayer.pushPageView({
            page_location: url,
            page_path: win.location.pathname,
            page_title: this.document.title,
            page_referrer: this.previousUrl || this.document.referrer,
            page_type: this.pageType(win.location.pathname),
            site_environment: this.environment(win.location.hostname),
            site_country: 'DE', site_currency: 'EUR', site_language: 'de-DE',
        });
        this.previousUrl = url;
        this.lastUrl = url;
    }

    private pageType(path: string): string {
        const segments = path.split('/').filter(Boolean);
        const route = segments.find(s => ['hotellist', 'ibeoffers', 'booka', 'bookp', 'booking', 'payment'].includes(s)) || '';
        if (route === 'hotellist') return 'search_results';
        if (route === 'ibeoffers') return 'hotel_detail';
        if (['booka', 'bookp', 'booking'].includes(route)) return 'checkout_traveller';
        if (route === 'payment') return path.endsWith('/success') ? 'booking_confirmation' : 'checkout_payment';
        return segments.length ? 'content' : 'home'; // TODO: campaign/account/contact route mapping needs product confirmation.
    }

    private environment(hostname: string): string {
        if (hostname.startsWith('stage.')) return 'stage';
        return environment.production ? 'prod' : 'dev';
    }
}
